import React from "react";
import { Form, Formik } from "formik";
import { defaultFilter, ISearchProps } from "./type";
import { SearchAccordion } from "../../../../../common";
import {
  generateSearchFormItem,
  getTreeData,
} from "../../../../../../utils/helper";
import { useTranslation } from "react-i18next";

const Search = ({ filter, setFilter }: ISearchProps) => {
  const { t } = useTranslation();

  return (
    <SearchAccordion>
      <Formik
        initialValues={filter}
        onSubmit={(values, { setSubmitting }) => {
          setFilter({ ...values, pages: 0 });
          setSubmitting(false);
        }}
      >
        {(form) => (
          <Form style={{ width: "100%" }}>
            {generateSearchFormItem(
              form,
              [
                {
                  type: "time",
                  name: "time",
                  label: "common.Time",
                },
                {
                  type: "multiSelect",
                  name: "place",
                  label: "AccessRecord.place",
                  treeData: getTreeData(["Lobby", "Club"]),
                },
                {
                  type: "multiSelect",
                  name: "clubID",
                  label: "AccessRecord.clubID",
                  treeData: getTreeData(["Club1", "Club2"]),
                },
                {
                  type: "multiSelect",
                  name: "clubID",
                  label: "AccessRecord.action",
                  treeData: getTreeData(["進入", "離開"]),
                },
                {
                  type: "text",
                  name: "ip",
                  label: "AccessRecord.ip",
                },
              ],
              defaultFilter(),
              t
            )}
          </Form>
        )}
      </Formik>
    </SearchAccordion>
  );
};

export default Search;
